var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinStackPathAdaptive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 138,
    viewBox: "0 0 100 138",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "organize-yourself-path-left",
    className: "organize-yourself-path-left",
    d: "M49.7564 0.046875L49.7564 42.2935C49.7564 45.6073 47.0701 48.2935 43.7564 48.2935L6.91407 48.2935C3.60036 48.2935 0.914062 50.9798 0.914062 54.2935L0.914057 137.044",
    stroke: "#675F77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "organize-yourself-path-right",
    className: "organize-yourself-path-right",
    d: "M49.7592 0.046875L49.7592 42.2937C49.7592 45.6074 52.4455 48.2936 55.7592 48.2936L92.6016 48.2936C95.9153 48.2936 98.6016 50.9799 98.6016 54.2936L98.6016 119.175",
    stroke: "#675F77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinStackPathAdaptive);
export default __webpack_public_path__ + "static/media/CoinStackPathAdaptive.5d897d3cb57bbb259fe49d56767ea0dd.svg";
export { ForwardRef as ReactComponent };